(function() { window.GUID_04a93dfa_1028_4ea2_b5da_3ad0ce926cfe = { getGuid: function() { return "04a93dfa-1028-4ea2-b5da-3ad0ce926cfe"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-resultsofpersona ",
                        callback: (accordion, e) => {
                            accordion.$Content.offon("click.accordionResultsofpersonaTabMenuClicked", `#tabmenu-resultsofpersona-${accordion.ContentId}`, (e) => {
                                const $closestTabMenuItem = $(e.target).closest(".tab-menu-item");
                                if ($closestTabMenuItem.length) {
                                    const { popupUrl } = $closestTabMenuItem.data("html");
                                    if (popupUrl) {
                                        accordion.RefreshContent(() => { }, popupUrl);
                                    }
                                }
                            });
                        }
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=results-of-persona.js.map
